export const FILTER_TYPES = {
  dynamicPlatformFilters: 'dynamicPlatformFilters',
  singleSelection: 'singleSelection',
  weightedSingleSelection: 'weightedSingleSelection',
  multiSelection: 'multiSelection',
  multiSelectionAsync: 'multiSelectionAsync',
  weightedMultiSelection: 'weightedMultiSelection',
  audienceAge: 'audienceAge',
  rangeSelection: 'rangeSelection',
  singleUserInput: 'singleUserInput',
  multiUserInput: 'multiUserInput',
} as const;
// eslint-disable-next-line @typescript-eslint/naming-convention -- CrmFilterType is the requested name
export type CrmFilterType = (typeof FILTER_TYPES)[keyof typeof FILTER_TYPES];

export type FilterSelection =
  | 'singleSelection'
  | 'weightedSingleSelection'
  | 'multiSelection'
  | 'multiSelectionAsync'
  | 'weightedMultiSelection'
  | 'rangeSelection'
  | 'singleUserInput'
  | 'multiUserInput'
  | 'audienceAge';

export type FilterOptionSelection = Extract<
  FilterSelection,
  | 'singleSelection'
  | 'weightedSingleSelection'
  | 'multiSelection'
  | 'multiSelectionAsync'
  | 'weightedMultiSelection'
  | 'audienceAge'
>;

export type UpdatableFilterOptionSelection = Extract<
  FilterOptionSelection,
  'weightedSingleSelection' | 'weightedMultiSelection' | 'audienceAge'
>;

export const FILTERS_GROUPS_IDS = ['creatorDetails', 'platforms'] as const;

export type FiltersGroupId = (typeof FILTERS_GROUPS_IDS)[number];

export type CreatorDetailsFilterId =
  | 'gender'
  | 'age'
  | 'location'
  | 'language'
  | 'category'
  | 'vettingDecision'
  | 'campaignHistory';

export type InstagramFilterId = 'followers' | 'engagementRate';

export type BasePlatformFilterId = 'followers' | 'engagementRate';

export type TiktokFilterId = 'followers' | 'engagementRate' | 'averageViews';

export type YoutubeFilterId = TiktokFilterId;

export type PlatformId =
  | 'all'
  | 'instagram'
  | 'facebook'
  | 'tiktok'
  | 'youtube'
  | 'twitter'
  | 'pinterest';

export type PlatformFilterId =
  | 'platform'
  | 'gender'
  | 'age'
  | 'location'
  | 'language'
  | 'platformMetrics';

export type FilterIds = CreatorDetailsFilterId | PlatformFilterId;

export type PlatformFilterIds =
  | InstagramFilterId
  | BasePlatformFilterId
  | TiktokFilterId
  | YoutubeFilterId;

export type FilterPresentation =
  | 'singleSelectionOptionsSegmentedControl'
  | 'weightedSingleSelectionOptionsSegmentedControl'
  | 'singleSelectionOptionsGridWithIcon'
  | 'singleSelectionOptionsRadioButtonsListWithIcon'
  | 'singleSelectionOptionsDropDown'
  | 'multiSelectionOptionsList'
  | 'multiSelectionOptionsDropDown'
  | 'multiSelectionOptionsAutocompleteAsync'
  | 'rangeSelectionSlider'
  | 'rangeSelectionSliderAndInput'
  | 'multiUserInputWithChips'
  | 'singleUserInput'
  | 'audienceAge'
  | 'platformFiltersGroup';
